module.exports = __webpack_public_path__ + "966d30e6099a4b18f71ad2992399e755.png";